module.exports = __webpack_public_path__ + "img/chevron-circle-down-solid.cb744923.svg";